<div>
    <h2 [ngClass]="{'component-title': (!subTitle || hideSearchSubTitle), 'component-title-with-subtitle': (subTitle && !hideSearchSubTitle)}" *ngIf="title && !hideSearchTitle">{{ title }}</h2>
    <div class="component-subtitle" *ngIf="subTitle && !hideSearchSubTitle">{{ subTitle }}</div>
</div>
<div *ngIf="actions">
    <ng-container *ngTemplateOutlet="actions"></ng-container>
</div>